module.exports = __webpack_public_path__ + "img/adv_jslx.3166681b.png";